/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 */

const baseUrl = 'eligibility-engine';
function freeze(value) {
  return Object.freeze(value);
}

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV2` from
 * `rpc-client-utils`.
 *
 * get-/eligibility-engine/v2/retail
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:RetailResource+type:symbol+getRetailIscEligibility&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Retail-get-%2Feligibility-engine%2Fv2%2Fretail'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/get/api.hubapi.com%2Feligibility-engine%2Fv2%2Fretail?showRequestDetails=true&body=&authType=app)</span></span><span style='padding-left: 12px'></span></span>
 */
export const getIsRetailRpc = freeze({
  baseUrl,
  method: 'get',
  pathSegments: freeze(['v2/retail'])
});